import React from "react";
import { useState, useEffect } from "react";


const Metro = (props) => {

    const {ruota,setRuota,corona,setCorona,
           rpm,setRpm,pignoni,setPignoni,
           pignone,setPignone,showMetro, setShowMetro, invertiCalcolo} = props

    const msToKmh = (speedMs) => (speedMs * 3600) / 1000;

    function getDate() {
        function pad(s) { return (s < 10) ? '0' + s : s; }
        var d = new Date()
        return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/')
      }

    const calcSpeedByRpmSprocketsWheelCircumference = (rpm,rapporto,circumference,binary) => {

        return (rpm / 60) * ((((rapporto)) * circumference) / 1000);
        
      };

      const generaRigheMetro = (pignoni,ruota,corona,rpm,binary = false) => {


        return pignoni.map(pignone => {

            //const rapporto = (binary) ? (corona/pignone) : (invertiCalcolo) ? (corona/pignone)*1.25 : (corona/pignone)/1.25

            let rapporto = 1

            if(invertiCalcolo) {
                rapporto = (binary) ? (corona/pignone)*1.25  : (corona/pignone)
            }
            else {
                rapporto = (binary) ? (corona/pignone)/1.25  : (corona/pignone)
            }

            const sviluppo = ruota.sviluppo
            const speed = msToKmh(calcSpeedByRpmSprocketsWheelCircumference(rpm,rapporto,sviluppo,binary))


            return {sviluppo: (Math.round((rapporto*sviluppo))/100), speed,pignone, corona: Math.round(pignone*rapporto)}
            

        })


    }

    const righe_binary_metro = generaRigheMetro(pignoni,ruota,corona,rpm,true)
    const righe_metro = generaRigheMetro(pignoni,ruota,corona,rpm,false)

    /* setMin1(righe1[righe1.length - 1].sviluppo - 10)
    setMax1(righe1[0].sviluppo + 30) */

    const min1 = righe_metro[righe_metro.length - 1].sviluppo - 10
    const max1 = righe_metro[0].sviluppo + 20
    let contatore  = 0
    let indice1 = 0
    let indice2 = 0

    const startCentimeter = min1; // Valore iniziale dei centimetri
    const endCentimeter = max1; // Valore finale dei centimetri

    const getLegenda = (binary) => {

        if(invertiCalcolo) {
            if(binary) return 'Speed 2'
  
            return 'Speed 1'
        }
        else {
          if(binary) return 'With Binary system'
  
          return 'Without system'
        }
      }

      const renderCentimeterMarks = (start, end, rows, rowsB, fontSize) => {
        const centimeterMarks = [];
        for (let i = start; i <= end; i++) {
      
          let addColor = false
          let addColor2 = false
          let sviluppo1 = 0
          let sviluppo2 = 0
          let pignone1 = 0
          let pignone2 = 0
          let corona1 = 0
          let corona2 = 0
      
      
          if(i < end-1) {
      
            for (let x = 0; x < rows.length; x++) {
            
              if(rows[x].sviluppo >= i && rows[x].sviluppo < i+1) {
                addColor = true
                sviluppo1 = rows[x].sviluppo
                pignone1 = rows[x].pignone
                corona1 = rows[x].corona
                break;
              }
            }
        
            for (let y = 0; y < rowsB.length; y++) {
              
              if(rowsB[y].sviluppo >= i && rowsB[y].sviluppo < i+1) {
                addColor2 = true
                sviluppo2 = rowsB[y].sviluppo
                pignone2 = rowsB[y].pignone
                corona2 = rowsB[y].corona
                break;
              }
            }
      
          }
      
          const valore = addColor ? Math.round(sviluppo1*10) : addColor2 ? Math.round(sviluppo2*10) : Math.round(i*10)
      
      
          centimeterMarks.push(
            <div style={styles.centimeterMarkContainer} key={i}>
              <div style={{marginRight: 10, fontSize: fontSize}}>
              {(valore/100).toFixed(2)} m
              </div>
              <div style={(addColor && addColor2) ? styles.centimeterLine00  : (addColor || addColor2) ? styles.centimeterLine0 : styles.centimeterLine} />
      
              {addColor && <div style={styles.centimeterLineCol1} />}
              {addColor && <div style={{fontSize: fontSize, marginRight: 5}}>{corona1 + '/' + pignone1}</div>}
              {addColor2 && <div style={styles.centimeterLineCol2} />}
              {addColor2 && <div style={{fontSize: fontSize, marginRight: 5}}>{corona2 + '/' + pignone2}</div>}
            </div>
          );
        }
        return centimeterMarks;
      };
      



    return (
    <div style={{flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '500px', overflow: 'scroll'}}>
            {renderCentimeterMarks(startCentimeter, endCentimeter,righe_metro, righe_binary_metro,'14pt')}
    </div>
    )



}

const styles = {
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'white',
  },
  scrollContainer: {
    alignItems: 'center'
  },
  centimeterMarkContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '80wv',
    marginBottom: 10,
    display: 'flex'
  },
  centimeter: {
    fontSize: 15,
    marginRight: 10,
  },
  centimeterLine: {
    width: '160px',
    height: 1,
    backgroundColor: '#000',
  },
  centimeterLine00: {
    width: '0px',
    marginRight: 10,
    height: 1,
    backgroundColor: '#000',
  },
  centimeterLine0: {
    width: '60px',
    marginRight: 10,
    height: 1,
    backgroundColor: '#000',
  },
  centimeterLineCol1: {
    width: '20px',
    height: 15,
    backgroundColor: 'red',
    borderRadius: 10,
    marginRight: 5
  },
  centimeterLineCol2: {
    width: '20px',
    height: 15,
    backgroundColor: 'black',
    borderRadius: 10,
    marginRight: 5
  }
}

export default Metro